import { render, staticRenderFns } from "./NonCassAppsInfo.vue?vue&type=template&id=32477cc2"
import script from "./NonCassAppsInfo.vue?vue&type=script&lang=js"
export * from "./NonCassAppsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports